import { listSearchSchema } from '@/shared/patterns/list-search';

import { productDebitAccountFilters } from './product-debit-account.filters';

export const PRODUCT_DEBIT_ACCOUNT_PATH = '/cadastro/produtos-liquidacao-automatica';
/** Tamanho inicial da lista do legado (`useState(10)`, ProductDebitAccountBatchFormContainer.tsx:42). */
export const PRODUCT_DEBIT_ACCOUNT_PAGE_SIZE = 10;
/** Limite de produtos por lote (`MAX_PRODUCTS`, ProductDebitAccountBatchFormContainer.tsx:36). */
export const PRODUCT_DEBIT_ACCOUNT_MAX = 100;

export const productDebitAccountSearch = listSearchSchema({
  ...productDebitAccountFilters.shape,
});
